import $ from 'jquery'

var setOp = {
    getProductId(url) {
        var array = url.split(`-`);
        return array[array.length - 1];
    },
    toTitles(s) {
        return s.replace(/\w\S*/g, function (t) {
            return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
        });
    },
    hideLoader() {
        $(`body`).removeClass(`vld-shown`);
        $(`.vld-overlay`).parent().remove();
    },
    clearHtml(html) {
        var temporalDivElement = document.createElement("div");
        // Set the HTML content with the providen
        temporalDivElement.innerHTML = html;
        // Retrieve the text property of the element (cross-browser support)
        return temporalDivElement.textContent /*.replace("<script", "[script")*/ || temporalDivElement.innerText/*.replace("<script", "[script")*/ || "";
    }
}

export default setOp